export enum PAGE {
  PROGRAM = 'program',
  MOVIE = 'movie'
}
